import { Box, Slider, Typography } from '@material-ui/core'

import { RangeFilterValue } from 'routes/highschools/utils/filter-utils'

import { PremiumWrapper } from '../PremiumPreview/PremiumWrapper'

type AcceptedPostSecondaryFields = Pick<
  FilterPostSecondaryProps,
  'pctAttendFourYearCollegeStudents' | 'pctAttendTwoYearCollegeStudents'
>
type FilterPostSecondaryProps = {
  pctAttendFourYearCollegeStudents?: RangeFilterValue
  pctAttendTwoYearCollegeStudents?: RangeFilterValue
  onChange: (
    formState: Partial<{
      pctAttendTwoYearCollegeStudents: RangeFilterValue
      pctAttendFourYearCollegeStudents: RangeFilterValue
    }>,
  ) => void
  enabled: boolean
}

type PostSecondarySliderProps = {
  label: string
  value?: RangeFilterValue
  ariaLabel: string
  fieldName: keyof AcceptedPostSecondaryFields
  onChange: (fieldName: keyof AcceptedPostSecondaryFields, value: RangeFilterValue) => void
  enabled: boolean
}

const PostSecondarySlider = ({ label, ariaLabel, value, fieldName, onChange, enabled }: PostSecondarySliderProps) => (
  <Box
    display="flex"
    flexDirection="column"
    gridGap={16}
  >
    <Typography variant="subtitle2">{label}</Typography>
    <Box
      pl={1}
      pr={2}
    >
      <Slider
        disabled={!enabled}
        value={[value?.min || 0, value?.max || 100]}
        onChange={(_, sliderValue) => {
          const [min, max] = sliderValue as number[]
          onChange(fieldName, {
            min: min === 0 && max !== 0 ? undefined : min,
            max: max,
          })
        }}
        getAriaValueText={(value: number) => `${value} percent`}
        getAriaLabel={(i) => {
          if (i === 0) return `${ariaLabel} minimum`
          return `${ariaLabel} maximum`
        }}
        valueLabelDisplay="auto"
        marks={[
          {
            value: 0,
            label: '0%',
          },
          {
            value: 100,
            label: '100%',
          },
        ]}
      />
    </Box>
  </Box>
)

const FilterPostSecondary = ({
  pctAttendFourYearCollegeStudents,
  pctAttendTwoYearCollegeStudents,
  onChange,
  enabled,
}: FilterPostSecondaryProps) => {
  const handleSliderChange = (fieldName: keyof AcceptedPostSecondaryFields, value: RangeFilterValue) => {
    onChange({ [fieldName]: value })
  }
  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap={24}
    >
      <Typography
        component="div"
        variant="h6"
      >
        Post-Secondary Enrollment
      </Typography>
      <PremiumWrapper
        enabled={enabled}
        trackingIdPlacement="post-secondary-filter"
      >
        <PostSecondarySlider
          label="% Enrolling in 4-Year Colleges"
          ariaLabel="Percent Enrolling in 4 Year College"
          value={pctAttendFourYearCollegeStudents}
          fieldName="pctAttendFourYearCollegeStudents"
          onChange={handleSliderChange}
          enabled={enabled}
        />
        <PostSecondarySlider
          label="% Enrolling in 2-Year Colleges"
          ariaLabel="Percent Enrolling in 2 Year College"
          value={pctAttendTwoYearCollegeStudents}
          fieldName="pctAttendTwoYearCollegeStudents"
          onChange={handleSliderChange}
          enabled={enabled}
        />
      </PremiumWrapper>
    </Box>
  )
}

export default FilterPostSecondary
